import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import {
  ModalContainer,
  CloseButton,
  ModalContent,
  ModalTitle,
  ButtonGroup,
  ConfirmButton,
  Row,
  CancelButton,
  Input,
  Label,
  InputContainer,
} from "./CreateFolderModal.styles";
import Modal from "../utils/Modal/Modal";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";

const CreateFolderModal = ({
  isOpen,
  onClose,
  onConfirm,
  folderName,
  setFolderName,
  isLoading = false,
}) => {
  useLockBodyScroll(isOpen);

  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      customOverlayStyles={{ zIndex: 3100 }}
    >
      <ModalContainer>
        <ModalContent>
          <Row>
            <ModalTitle>Create Folder</ModalTitle>
            <CloseButton onClick={handleCancel}>
              <CloseSvg width={20} height={20} />
            </CloseButton>
          </Row>

          <InputContainer>
            <Label>Folder Name</Label>
            <Input
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
              placeholder="Enter a name for your folder"
            />
          </InputContainer>

          <ButtonGroup>
            <CancelButton onClick={handleCancel} disabled={isLoading}>
              Cancel
            </CancelButton>
            <ConfirmButton
              onClick={handleConfirm}
              $type="primary"
              disabled={isLoading}
            >
              {isLoading ? (
                <l-line-spinner size="20" stroke="2" speed="1" color="#000" />
              ) : (
                "Create"
              )}
            </ConfirmButton>
          </ButtonGroup>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default CreateFolderModal;
